module.exports = __webpack_public_path__ + "img/zhaf.86c24ca1.png";